import request from "@/utils/request";

export function upload(files) {
    return request({
        url: 'chikyMap/uploadDecryptFiles',
        method: 'post',
        data: files
    })
}
